import React from 'react';

import {DirectoryForm} from 'components/directory-form';
import {IPageTemplateProps} from 'pages';

export interface IDirectoryFormPageProps extends IPageTemplateProps {
}

export const DirectoryFormPage = ({...props}: IDirectoryFormPageProps) => (
    <DirectoryForm {...props} />
);
